(function () {
  'use strict';

  function initFilterDrawer(drawerId, overlaySelector, closeSelector, toggleSelector) {
    var drawer = document.getElementById(drawerId);
    var overlay = document.querySelector(overlaySelector);
    var toggle = document.querySelector(toggleSelector);
    if (!drawer || !toggle) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
      }
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('filter-drawer-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
      }
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filter-drawer-open');
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest(closeSelector) || e.target.closest(overlaySelector)) {
        closeDrawer();
        toggle.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
        toggle.focus();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFilterDrawer(
      'filter-drawer-collection',
      '[data-filter-overlay]',
      '[data-filter-close]',
      '[aria-controls="filter-drawer-collection"]'
    );
    initFilterDrawer(
      'filter-drawer-search',
      '[data-filter-overlay-search]',
      '[data-filter-close-search]',
      '[aria-controls="filter-drawer-search"]'
    );
  });
})();
